// @flow

import { format, parse } from 'url';
import ENV from '../env';
import defaultContext from './context';

type URL = {
  auth?: string,
  hash?: string,
  host?: string,
  hostname?: string,
  href: string,
  path?: string,
  pathname?: string,
  port?: string,
  protocol?: string,
  query?: {
    [key: string]: string
  },
  search?: string,
  slashes?: boolean
};

type Location = URL | string;

type History = {
  createLocation: (location: Location) => void,
  createPath: (location: Location) => void,
  createHref: (location: Location) => void,
  push: (location: Location) => void,
  replace: (location: Location) => void
};

type Factory = (options: Object) => History;

type Options = {
  context?: Object
};

const normalize = (location: Location): URL =>
  typeof location === 'string' ? (parse(location): URL) : (location: URL);

const isEmbeddedPathname = (location: Location) => {
  const { pathname } = normalize(location);
  const pattern = new RegExp(ENV.PUSHBOT_EMBEDDED_PATHNAME);
  return pathname && pattern.test(pathname);
};

export default function useEmbeddedPathname(
  createHistory: Factory,
  options?: Options
): Factory {
  const { context = defaultContext } = options || {};
  return function(options: Object): History {
    const history = createHistory(options);

    try {
      // parse embedded mode variable
      const embeddedMode = JSON.parse(ENV.PUSHBOT_EMBEDDED_MODE);

      // return current history if embedded is disabled
      if (!embeddedMode) {
        return history;
      }

      const push = (location: Location) => {
        if (isEmbeddedPathname(location)) {
          return history.push(location);
        }
        context.location.href = format(normalize(location));
      };

      const replace = (location: Location) => {
        if (isEmbeddedPathname(location)) {
          return history.replace(location);
        }

        context.location.replace(format(normalize(location)));
      };

      return {
        ...history,
        push,
        replace
      };
    } catch (e) {
      // if parse fials, just return the history object
      return history;
    }
  };
}



// WEBPACK FOOTER //
// ./js/util/useEmbeddedPathname.js